<template>
<div>
  <div class="welfareListBox">
     <div v-for="item in welfareLists" class='welfareRow'  :key='item.id'>
       <router-link :to="{ name: 'welfareItem', params: { id: item.id }}" class='welfareListItem'>
         <div>
           <img :src="item.listPic"  class='banner'>
         </div>
         <div class="welfareListItemInfo">
           <div class="title">
             <span>{{item.title}}</span>
           </div>
           <div class='welfareListItemInfo_btm'>
             <div class='attention'>
               {{item.attention}}
             </div>
             <div class="moreInfo">
               <div class="companyinfo">
                 <div>
                   <img :src="item.logo" class="logo">
                 </div>
                 <div class='befrom'>
                   <span>{{item.name}}</span>
                 </div>
               </div>
               <div>
                 <div class='num'>
                   <span>查看人数：{{item.qmVisitCount}}</span>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </router-link>
     </div>
   </div>

 <div class="noData" >
   <text>主人，暂时没有更多优惠券。</text>
 </div>

</div>
</template>
<script type = "text/ecamscript-6">
  export default {
    name:"welfareList",
    props:['sponserCatalogid','selectType'],
    data(){
      return{
        welfareLists:[],
        REQUIRE:false,
        page:1,
        pageSize:10
      }
    },
    watch:{
      sponserCatalogid:function(){
        this.welfareLists = [],
        this.page = 1
        this.login()
      }
    },
    created () {
      this.login()
      //console.log(this.sponserCatalogid)
    },
    methods:{
      /*axios调用nav*/
       login () {
         this.url = "api/getWelfareList.php?sponserCatalogid="+this.sponserCatalogid+"&selectType="+this.selectType+"&page="+this.page+"&pageSize="+this.pageSize
         //console.log(this.url )
         this.$ajax.autoService
             .login(this.url)
             .then((res) => {
               this.welfareLists = this.welfareLists.concat(res.data.map(function(item){
                 return item
               }))
               this.$nextTick(() => {
                 this.REQUIRE = true;
                 this.loading = false;
               });
              //console.log(this.welfareLists)
             }, (res) => {
                 console.log("error")
             })
        },
        /*axios向下加载*/
        scrollBottom() {
         // 滚动到页面底部时，请求前一天的文章内容
         var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
         if (((window.screen.height + scrollTop) > (document.body.clientHeight))-10 && this.REQUIRE) {
           // 请求的数据未加载完成时，滚动到底部不再请求前一天的数据
           this.REQUIRE = false;
           this.loading = true;
           this.tips = '努力加载中...';
           this.page+=1
           this.login(this.url)

     }
   }
 },
 mounted(){
   window.onscroll = this.scrollBottom
 }
  }
</script>
<style lang="stylus">
  .welfareListBox
    width: 100%
    display: flex
    flex-direction: column
    .welfareRow
      width: 100%
      box-sizing: border-box
      background: #fff
      padding: 0 30px
      .welfareListItem
        border-bottom: 1px solid #eee
        /*px*/
        padding: 30px 0
        display: flex
        flex-direction: row
        justify-content: space-between
        .banner
          width: 200px
          height:200px
          display: block
        .welfareListItemInfo
          display: flex
          flex-direction: column
          width:100%
          height: 200px
          justify-content: space-between
          padding-left: 30px
          box-sizing: border-box
          .title
            width: 450px
            font-size: 34px
            height: 80px
            color: #000
            overflow: hidden
            text-overflow: ellipsis
            display: -webkit-box
            -webkit-line-clamp: 2
            -webkit-box-orient: vertical
            line-height: 40px
          .attention
            font-size:32px
            color:#f40
            line-height: 40px
          .moreInfo
            display: flex
            flex-direction: row
            font-size: 25px
            color: #aaa
            justify-content: space-between
            margin-top: 5px
            line-height: 40px
            .companyinfo
              display: flex
              flex-direction: row
              .logo
                width:30px
                height:30px
                vertical-align: middle
                margin: 5px
              .befrom
                font-size: 28px
                color: #333
                vertical-align: middle
            .num
              font-size: 28px
              color: #999
</style>



// WEBPACK FOOTER //
// src/components/welfare/welfareList.vue